import * as angular from "angular";

export class EventService {
    private v2Root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/event";
    }

    canvasses(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/canvasses", data);
    }

    all(data: any): Promise<object> {
        return this.$http.get(this.v2Root, { params: data });
    }

    user(params: any): Promise<object> {
        return this.$http.get(this.v2Root + "/user", { params: params });
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/" + data.id);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/" + data.id, data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root, data);
    }

    between(data: any): Promise<object> {
        let start = data.start && data.start != "" ? "/" + data.start : "";
        let end = data.end && data.end != "" ? "/" + data.end : "";
        return this.$http.get(this.v2Root + "/between" + start + end, {
            params: data,
        });
    }

    rsvp(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/rsvp/" + data.id, data);
    }

    getRsvp(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/rsvp/" + data.id);
    }

    cancel(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/cancel/" + data.id);
    }
}

angular.module("vcServices").service("EventService", EventService);
